module.exports = __webpack_public_path__ + "img/17.2c96ee83.jpg";